// Recital act stage-time helpers.
// Durations are stored in SECONDS (durationSecs). Class acts default to 2:30 —
// a recital dance, never the class length from the schedule.

export const DEFAULT_CLASS_ACT_SECS = 150;

/** Effective duration in seconds (falls back to legacy durationMins rows). */
export const actDurationSecs = (act) => {
    if (act?.durationSecs != null) return act.durationSecs;
    if (act?.durationMins != null) return act.durationMins * 60;
    return null;
};

/** 150 → "2:30"; null → "". */
export const formatSecs = (secs) => {
    if (secs == null || Number.isNaN(Number(secs)) || secs < 0) return '';
    const total = Math.round(Number(secs));
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
};

/**
 * Parse what a studio might type into the duration box → seconds, or null if
 * unreadable. Accepts "2:30" (m:ss), "2.5" (decimal minutes), "3" (minutes).
 * Capped at 4 hours — nobody's act runs longer, and it catches typos.
 */
export const parseDurationInput = (raw) => {
    if (typeof raw !== 'string') return null;
    const str = raw.trim();
    if (!str) return null;

    const MAX_SECS = 4 * 60 * 60;

    // m:ss
    let m = str.match(/^(\d{1,3}):([0-5]?\d)$/);
    if (m) {
        const secs = Number(m[1]) * 60 + Number(m[2]);
        return secs > 0 && secs <= MAX_SECS ? secs : null;
    }

    // plain or decimal minutes
    m = str.match(/^(\d{1,3}(?:[.,]\d{1,2})?)$/);
    if (m) {
        const mins = Number(m[1].replace(',', '.'));
        const secs = Math.round(mins * 60);
        return secs > 0 && secs <= MAX_SECS ? secs : null;
    }

    return null;
};
